/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_UsageInputs */

const en_settings_overview_usage = /** @type {(inputs: Settings_Overview_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage`)
};

const zh_settings_overview_usage = /** @type {(inputs: Settings_Overview_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用量`)
};

/**
* | output |
* | --- |
* | "Usage" |
*
* @param {Settings_Overview_UsageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_overview_usage = /** @type {((inputs?: Settings_Overview_UsageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_UsageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_overview_usage(inputs)
	return zh_settings_overview_usage(inputs)
});
export { settings_overview_usage as "settings.overview.usage" }